<template>
  <div class="chargeoff-con">
    <NavBar
      title="核销"
      left-arrow
      @click-left="goBack"
      v-if="isWeixin_status == false"
    />
    <Cell :title="'服务项目：'+detail_info.service.name" >
    </Cell>
    <Cell :title="'消耗积分：'+detail_info.score" >
    </Cell>
    <Cell :title="'订单编号：'+ detail_info.ordersn"   >
    </Cell>
    <Cell :title="'下单时间：'+detail_info.create_time" >
    </Cell>
    <Cell title="核销状态">
      <Tag v-if="detail_info.is_use !== 1" type="danger" size="primary">未使用</Tag>
      <Tag v-else type="danger" size="large">已使用</Tag>
    </Cell>
    <div class="scan-con" v-if="!detail_info.is_use">
      <div class="scan-img">
        <img v-lazy="detail_info.url" alt="">
      </div>
      <p class="show-text">请将该二维码展示给商家核销</p>
      <div class="my-check" v-if="detail_info.is_use !== 1">
        <Button type="primary" @click="verifSelfcoupon">自助核销</Button>
      </div>
    </div>


  </div>
</template>
<script>
import washCar from "@/api/washCar";
import { NavBar, Cell, Button, Dialog,Tag } from 'vant';
export default {
  components: {
    NavBar,
    Cell,
    Button,
    Tag,
    [Dialog.Component.name]: Dialog.Component,
  },
  data() {
    return {
      detail_info: {
        service: {
          name: '',
          is_verify:''
        },
        ordersn: '',
        score: '',
        create_time: ''
      }
    }
  },
  created() {
    if (this.$route.query.type) {
      this.getDetail(this.$route.query.type);
    }
  },
  methods: {
    async getDetail(idx) {
      try {
        const res = await washCar.getStoreServePayDetail(idx);
        if (res.code == 200) {
          this.detail_info = res.data;
        } else {
          throw(res.msg);
        }
      } catch (error) {
        console.log(error);
      }
    },
    // 核销洗车券
    async verifSelfcoupon() {
      Dialog.confirm({
        title: '温馨提示',
        message: '确认使用吗,核销后不可再次使用!',
        // theme: 'round-button',
      }).then(() => {
        washCar.getVerifSelf(this.detail_info.ordersn).then((res)=> {
          if (res.code == 200) {
            this.$toast('核销成功!')
            this.getDetail(this.$route.query.type);
          } else {
            this.$toast(res.msg)
          }
        })
      }).catch(()=> {
        console.log('取消核销')
      })

    }
  }
}
</script>
<style lang="scss" scoped>
.chargeoff-con {
  width: 100%;
  height: 100vh;
  background-size: cover;
  background-color: rgba(244,244,244,1);
  .my-check {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 20px;
    button {
      width: 180px;
      height: 40px;
      font-weight: 500;
    }
  }
  .scan-con {
    width: 100%;
    height: 60vh;
    background: #ffffff;
    padding: 20px 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    color: #000000;
    .scan-time {
      width: 100%;
      height: 30px;
      display: flex;
      font-size: 14px;
      border-bottom: 1px solid #dfdfdf;
      justify-content: space-between;
    }
    .scan-title {
      width: 100%;
      height: 60px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      text-align: center;
      margin-top: 10px;
      span:nth-child(2) {
        color: #000000;
        font-size: 20px;
      }
    }
    .show-text {
      font-size: 14px;
      font-weight: 400;
    }
    .scan-img {
      width: 250px;
      height: 250px;
      border-radius: 3px;
      display: flex;
      align-items: center;
      margin: 10px;
      border: 1px solid #dfdfdf;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>